import { useEffect } from 'react';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as CapLedgerService from '@/services/capLedgerService';

const ledgerEvent$ = new Subject<any>();

export const useLedgerStream = () => {
  useEffect(() => {
    const channel = CapLedgerService.subscribeToLedgerEvents((payload) => {
      ledgerEvent$.next(payload);
    });

    const sub = ledgerEvent$.pipe(debounceTime(250)).subscribe((event) => {
      console.log('🪶 Ledger update:', event);
    });

    return () => {
      sub.unsubscribe();
      CapLedgerService.unsubscribeFromChannel(channel);
    };
  }, []);

  return ledgerEvent$;
};
